import React from 'react';
import Title from '@/components/Title';

import Button from '@/components/Button';
import { BlogPost } from '@/components/Home/home';
import BlogPostItem from '@/components/BlogPostItem';
import useGTM from '@/hooks/useGtag';
import { traceEvent } from '@wk/wk-gatherer';

import { useTranslation } from 'next-i18next';
import useBlogList from '@/hooks/useBlogList';
import { Post } from '@/request/interface/common';

export interface IBlogProps {
  blogPosts: BlogPost[];
}

const Blog = () => {
  const { t, i18n } = useTranslation(['path', 'math']);
  const { blogList } = useBlogList({
    storeName: `blog-list-math-${i18n.language}`,
    cat_id: i18n.language === 'zh' ? '132672' : '134689',
  });

  const sendDataToGTM = useGTM();
  const handleGA = (gaName?: string, extra: { [key: string]: any } = {}) => {
    // 获取当前路径
    const gaNameFix = `O_MathCourse_Blog_${gaName}`;
    sendDataToGTM(gaNameFix);
    traceEvent({
      data: {
        _event: gaNameFix,
        ...extra,
      },
    });
  };

  const handleClick = (data: Post) => {
    handleGA('ArticleClick', {
      article_name: data?.post_title,
      article_type: data?.post_id,
      Article_url: data?.post_link,
    });
  };

  return (
    <section className="marginModelTop  relative pt-5 text-center  lg:pt-[30px] xl:pt-8">
      <div className=" relative z-10">
        <div className="container">
          <Title className="relative mb-6 inline-block lg:mb-8 xl:mb-12" innerHTML theme="math">
            {`${t('math:BLOG标题')}<div class="absolute right-[-100px] top-[-45px] hidden h-[80px] w-[80px] shrink-0 rotate-[-15deg] items-center justify-center rounded-[20px] bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] shadow-[0px_33px_50px_0px_rgba(0,0,0,0.06)] lg:flex xl:flex">
          <img class="w-[49px]" src="/images/english/trumpet.png" alt="" />
          <img class="absolute right-[-30px] top-[20px] w-[39px]" src="/images/english/rectangle.png" alt="" />
        </div>`}
          </Title>
        </div>

        <div className=" container">
          <BlogPostItem post={blogList} handleClick={handleClick} />
          <div>
            <Button
              href={t('path:博客')}
              target="_blank"
              size="xl"
              className="mt-6 lg:mt-12 xl:mt-[60px] [&]:text-base [&]:font-medium [&]:xl:text-xl"
              traceName="O_MathCourse_Blog_MoreClick"
            >
              {t('math:探索更多')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
